module.exports = __webpack_public_path__ + "img/碳排监测@1x.2c18f644.png";